module.exports = __webpack_public_path__ + "static/media/Payment.758fef1e.svg";